
import React from "react";
import { Label } from "@/components/ui/label";

interface ColorsSectionProps {
  colors: string[];
  updateBusinessData: (key: string, value: any) => void;
}

const ColorsSection: React.FC<ColorsSectionProps> = ({ 
  colors,
  updateBusinessData
}) => {
  if (!colors || colors.length === 0) return null;
  
  return (
    <div className="space-y-2">
      <Label>Brand Colors</Label>
      <div className="flex gap-2 p-4 bg-muted/10 rounded-lg">
        {colors.map(color => (
          <div 
            key={color} 
            className="h-8 w-8 rounded-full border"
            style={{ backgroundColor: color }}
            title={color}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorsSection;
